// src/pages/AdminDashboard.tsx
import React from "react";
import { Layout } from "@layouts/MainLayout";

const AdminDashboard: React.FC = () => {
  return (
    <Layout>
      <h1 className="text-3xl font-semibold">Admin Dashboard</h1>
      <p className="mt-4">
        Welcome to your Admin Dashboard. You can manage your system here.
      </p>
    </Layout>
  );
};

export default AdminDashboard;
